// src/components/MaintenanceScreen.js
import React, { useEffect } from 'react';

const MaintenanceScreen = () => {
  // Función para normalizar saltos de línea
  const normalizeNewlines = (text) => (text || '').replace(/\\n/g, '\n');

  // Obtener configuración desde variables de entorno
  const title = process.env.REACT_APP_MAINTENANCE_TITLE || 'Sistema en Mantenimiento';
  const message = normalizeNewlines(
    process.env.REACT_APP_MAINTENANCE_MESSAGE || 
    'Estamos realizando mejoras en nuestro sistema.\\nVolveremos pronto con nuevas funcionalidades.'
  );
  const contact = normalizeNewlines(
    process.env.REACT_APP_MAINTENANCE_CONTACT || 
    'Para consultas urgentes, contacta al equipo de soporte técnico.'
  );

  useEffect(() => {
    // Cargar los estilos de Mazer para mantener consistencia
    const appStyle = document.createElement('link');
    appStyle.rel = 'stylesheet';
    appStyle.href = `${process.env.PUBLIC_URL}/assets/css/app.css`;
    document.head.appendChild(appStyle);

    const authStyle = document.createElement('link');
    authStyle.rel = 'stylesheet';
    authStyle.href = `${process.env.PUBLIC_URL}/assets/css/auth.css`;
    document.head.appendChild(authStyle);

    // Limpiar cuando se desmonte el componente
    return () => {
      if (document.head.contains(appStyle)) {
        document.head.removeChild(appStyle);
      }
      if (document.head.contains(authStyle)) {
        document.head.removeChild(authStyle);
      }
    };
  }, []);

  return (
    <div id="auth">
      <div className="row h-100">
        <div className="col-lg-5 col-12">
          <div id="auth-left">
            <div className="auth-logo">
              <img 
                src={process.env.REACT_APP_CLIENT_LOGO || '/assets/images/cirenio.svg'} 
                alt="Client Logo" 
              />
            </div>
            
            {/* Ícono de mantenimiento sobre el título */}
            <div className="text-center mb-3">
              <div className="maintenance-icon-wrapper">
                <i className="bi bi-tools text-warning" style={{ fontSize: '2.5rem' }}></i>
              </div>
            </div>

            {/* Título principal */}
            <h1 className="auth-title text-center">{title}</h1>
            
            {/* Mensaje principal */}
            <div className="text-center mb-5">
              {message.split('\n').map((line, index) => (
                <p key={index} className="auth-subtitle">{line}</p>
              ))}
            </div>

            {/* Información de contacto */}
            {contact && (
              <div className="mb-5">
                <div className="alert alert-light-info">
                  <div className="d-flex align-items-center">
                    <i className="bi bi-info-circle me-2 mb-2 text-info"></i>
                    <div>
                      {contact.split('\n').map((line, index) => (
                        <div key={index} className="small">
                          {line}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Mensaje final */}
            <div className="text-center">
              <small className="text-muted">
                Gracias por tu paciencia
              </small>
            </div>
          </div>
        </div>

        {/* Panel derecho con logo de Cirenio - igual que en AuthLayout */}
        <div className="col-lg-7 d-none d-lg-block">
          <div id="auth-right">
            <img src="/assets/images/logo-cirenio-white.svg" alt="Cirenio Logo" className="cirenio-logo" />
          </div>
        </div>
      </div>


      {/* Estilos específicos para el modo mantenimiento */}
      <style dangerouslySetInnerHTML={{
        __html: `
          .maintenance-icon-wrapper {
            animation: pulse 2s infinite;
          }
          
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.05); }
            100% { transform: scale(1); }
          }
        `
      }} />
    </div>
  );
};

export default MaintenanceScreen;
